import React from 'react';
import { Route, Switch, Redirect, withRouter } from 'react-router-dom';
import { dispatch } from '@rematch/core';
import SplitPane from "react-split-pane";
import { push } from "react-router-redux";
import '@zippytech/react-toolkit/SplitContainer/index.css';

import MenuItem from "../common/MenuItem";
import NotFound from "../common/NotFound";
import SettingsLinkItem from "../common/SettingsLinkItem";
import { getUserCache } from '../../helpers/userCacheManager';

import { Home } from './home';
import { Organization } from './organization';
import { ContentManager } from "./contentManager";
import { LifecycleDesigner } from "./lifecycleDesigner";
import { Initiatives } from "./Initiatives";
import { Activities } from "./activities";
import { WSSetting } from "./wsSetting";
import { Demo } from "./Demo";
import UserCache from "../../helpers/cache/userCache";
// import { CommanderdTemplate } from "./commanderTemplate";
// import { CommanderdDashboard } from './commanderDashboard';

import Marketplace from './marketplace';
import Portfolio from "./portfolio";
import AIntelligence from "./artificialIntelligence";

import './styles.css';
import './../common/common.css';

class Workspace extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            contentCount: 0,
            playbookCount: 0
        }
    }

    async UNSAFE_componentWillMount() {
        dispatch.app.baseModuleType("Workspace")
        let userCache = await getUserCache(this.props.user._id);

        if (this.props.match.params.accountId !== this.props.selectedAccount._id) {
            if (userCache.hasVertex(this.props.match.params.accountId)) {
                dispatch.account.selectAccount({ accountId: this.props.match.params.accountId });
            }
        }
        if (userCache.hasVertex(this.props.match.params.workspaceId)) {
            dispatch.initiatives.selectedOrganizationFromParam(this.props.match.params.workspaceId)

        }
        else {
            return dispatch(push(`/app/${this.props.match.params.accountId}/404`));
        }
    }
    componentDidMount() {
      //  dispatch.app.getPublicCategoriesAsync();
        if (this.props.userCache) {
            const userCacheObject = new UserCache(this.props.userCache);
            const orgDataMap = userCacheObject.getAccountWorkspaceDataStats();
            orgDataMap.get(this.props.match.params.workspaceId) && this.setState({ contentCount: orgDataMap.get(this.props.match.params.workspaceId).totalContents, playbookCount: orgDataMap.get(this.props.match.params.workspaceId).totalPlayBooks })
        }
    }
    render() {

        const { handleConfigVisibleChange, handleHelpVisibleChange, selectedOrganisation, selectedAccount } = this.props;
        let memberRole = selectedOrganisation && selectedOrganisation.role === 'Member';
        let templatePermission = this.props.user.permissions && this.props.user.permissions.filter(permission => { return permission.name === "templateCreation" }).length > 0;
        let dashboardPermission = this.props.user.permissions && this.props.user.permissions.filter(permission => { return permission.name === "dashboardCreation" }).length > 0;
        // let contentPath = this.props.contentPath ? `/app/${selectedAccount._id}/_ws/${this.props.match.params.workspaceId}/_ct/${this.props.contentPath.split('_ct/')[1]}` : this.state.contentCount >= 0 ? `/app/${selectedAccount._id}/_ws/${this.props.match.params.workspaceId}/_ct/status/knowledgeBank` : `/app/${selectedAccount._id}/_ws/${this.props.match.params.workspaceId}/_ct/status/publicKnowledgeBank`;
        // let playbookPath = this.props.playbookPath ? `/app/${selectedAccount._id}/_ws/${this.props.match.params.workspaceId}/_pb/${this.props.playbookPath.split('_pb/')[1]}` : this.state.playbookCount >= 0 ? `/app/${selectedAccount._id}/_ws/${this.props.match.params.workspaceId}/_pb/status/knowledgeBank` : `/app/${selectedAccount._id}/_ws/${this.props.match.params.workspaceId}/_pb/status/publicKnowledgeBank`; // KLM-8964
        let menu_bar =
            <div className="setMenu" style={{ height: "calc(100% - 50px)" }}>
                 <ul className="aspenMenu topMenu">
                    <div className="vert vert_design"> Innovate {/* Designer */} </div>
                    <MenuItem
                        to={`/app/${selectedAccount._id}/_ws/${this.props.match.params.workspaceId}/_pb`}
                        className={"designer"}
                        name="Playbook Designer"
                        resourcePaneFunction={dispatch.lifeCycle.showResourecePane} />
                    <MenuItem
                        to={`/app/${selectedAccount._id}/_ws/${this.props.match.params.workspaceId}/_ct`}
                        className={"contentManagement"}
                        name="Content Manager"
                        resourcePaneFunction={dispatch.content.openResourcePane} />
                </ul>
                <ul className="aspenMenu topMenu">
                    <div className="vert vert_conductor"> Perform {/* Navigator */} </div>
                    <MenuItem
                        to={memberRole ? "#" : `/app/${selectedAccount._id}/_ws/${this.props.match.params.workspaceId}/_in`}
                        className={memberRole ? "initiatives disable-menu" : "initiatives"}
                        name="Initiative Manager"
                        resourcePaneFunction={dispatch.initiatives.showResourecePane} />
                    <MenuItem
                        to={`/app/${selectedAccount._id}/_ws/${this.props.match.params.workspaceId}/_at/myactivities`}
                        className={`activities`}
                        name="My Progress View"
                        resourcePaneFunction={dispatch.initiatives.showResourecePane} />
                </ul>
                <ul className="aspenMenu topMenu">
                    <div className="vert vert_home"> Connect {/* Conductor */}</div>
                    <MenuItem
                        to={memberRole ? "#" : `/app/${selectedAccount._id}/_ws/${this.props.match.params.workspaceId}/home`}
                        className={memberRole ? "home disable-menu" : "home"}
                        name="Workspace Home"
                    />
                    <MenuItem
                        to={memberRole ? "#" : `/app/${selectedAccount._id}/_ws/${this.props.match.params.workspaceId}/_cm`}
                        className={memberRole ? "community disable-menu" : "community"}
                        name="Community Management" />
                </ul>
               
                

                {/* <ul className="aspenMenu topMenu " >
                    <div className="vert vert_exchange"> Exchange </div>
                    <MenuItem
                        to={`#`}
                        className="Marketplace disable-menu-Exchange"
                        name="Marketplace"
                    />
                    <MenuItem
                        to={`#`}
                        className="ai disable-menu-Exchange"
                        name="Analytics"
                    />
                </ul> */}
            </div>



        return (
            <SplitPane defaultSize="79.5px" split="vertical" allowResize={false}
                pane1Style={{ backgroundColor: "#fbfbfb" }}
                pane2Style={{ backgroundColor: "#f5f8fa" }}
            >
                <div className="aspenToolBar">
                    <audio id="beepOne" style={{ display: "none" }} ref="beepOne" controls="controls" preload="auto">
                        <source src="/audio/beep.mp3"></source>
                        <source src="/audio/beep.ogg"></source>
                    </audio>

                    {menu_bar}
                    <ul className="aspenMenu bottomMenu top_brdr">
                        {selectedOrganisation.role === 'workspaceOwner' ? (
                            <div className="vert vert_settings_help">Settings & Help</div>
                        ): (
                            <div className="vert vert_settings_help">Help</div>
                        )}
                        {selectedOrganisation.role === 'workspaceOwner' && <MenuItem
                            to={`/app/${selectedAccount._id}/_ws/${this.props.match.params.workspaceId}/_wsSetting`}
                            className={`settings`}
                            name="Setting"
                        />}
                        <SettingsLinkItem name="Visit Aspenify Support" className="help" action={handleHelpVisibleChange} />
                    </ul>
                </div>
                <div className="mainContent" >

                    <Route path={`/app/:accountId/_ws/:workspaceId/home`} component={Home} />
                    <Route path={`/app/:accountId/_ws/:workspaceId/portfolio`} component={Portfolio} />
                    <Route path={`/app/:accountId/_ws/:workspaceId/_in`} component={Initiatives} />
                    <Route path={`/app/:accountId/_ws/:workspaceId/_at/:myactivities`} component={Activities} />
                    <Route path={`/app/:accountId/_ws/:workspaceId/_ct`} component={ContentManager} />
                    <Route path={`/app/:accountId/_ws/:workspaceId/_pb`} component={LifecycleDesigner} />
                    <Route path={`/app/:accountId/_ws/:workspaceId/_cm`} component={Organization} />
                    <Route path={`/app/:accountId/_ws/:workspaceId/_wsSetting`} component={WSSetting} />
                    <Route path={`/app/:accountId/_ws/:workspaceId/marketplace`} component={Marketplace} />
                    <Route path="/app/:accountId/_ws/:workspaceId/404" component={NotFound} />
                    <Route path={`/app/:accountId/_ws/:workspaceId/ai`} component={AIntelligence} />
                    <Route path={`/app/:accountId/_ws/:workspaceId/_dm`} component={Demo} />

                </div>
            </SplitPane>
        );
    }
}

export default withRouter(Workspace);